// Voult auth shim: reuses the CITIDAN session (no separate Voult login).
import { useAuth as useCitidanAuth } from "@/context/AuthContext";

export const useAuth = () => {
  const { user, logout } = useCitidanAuth();
  const u = user ? { ...user, full_name: user.full_name || user.name || user.email } : user;
  return { user: u, isAuthenticated: !!user, isLoadingAuth: user === undefined, authChecked: user !== undefined, logout };
};
